import React from 'react';

export default function AdminPageLayout({ title, headerActions, listContent, detailContent, children, className }) {
  return (
    <div className={`admin-page ${className || ''}`}>
      <div className="admin-page-header">
        <h2>{title}</h2>
        {headerActions}
      </div>
      <div className="admin-page-layout">
        <div className="admin-page-list">{listContent}</div>
        <div className="admin-page-detail">{detailContent}</div>
      </div>
      {children}
    </div>
  );
}
